import React, { useState, useEffect } from 'react';

import { Col, Row } from "react-bootstrap";

import Plaid from "Components/FundingSources/Plaid";
import Manual from "Components/FundingSources/Manual";
import Loading from "Components/Loading";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";
import useRedirectUrl from "Utils/Hooks/useRedirectUrl";
import AddFundingSourceError from "Assets/Img/AddFundingSourceError.png";
import useOAuthStateId from "Utils/Hooks/useOAuthStateId";
import useAppKey from 'Utils/Hooks/useAppKey';
import useSession from "Utils/Hooks/useSession";

const FundingSourceList = (props) => {

  const { session } = useSession();
  const vipApi = useVipApiFetcher();
  const [isLoading, setIsLoading] = useState(true);
  const [linkToken, setLinkToken] = useState(false);
  const url = useRedirectUrl();
  const appKey = useAppKey();
  const oauth_state_id = useOAuthStateId();
  const [receivedRedirectUri, setReceivedRedirectUri] = useState(null);

  // Get Plaid Link token
  useEffect(() => {
    if (props.plaidRedirect) {
      setLinkToken(localStorage.getItem("link_token"));
      setReceivedRedirectUri(url ? url + "?oauth_state_id=" + oauth_state_id : (window.location.href.includes('oauth_state_id=') ? window.location.href : window.location.href + "?oauth_state_id=" + oauth_state_id));
      // setReceivedRedirectUri("https://cdn.plaid.com/link/v2/stable/oauth.html?oauth_state_id=" + oauth_state_id);
      return;
    }
    if (session.toggles.plaidEnabled && !props.plaidRedirect) {
      let mounted = true;
      let oprUrl = '';
      if (url) {
        oprUrl = appKey ? "?redirectUri=" + url + "/" + appKey : "?redirectUri=" + url;
      }
      else {
        let basePlaidRedirectUri = window.location.href.includes('oauth_state_id=') ? window.location.href.split('?')[0] : window.location.href;
        let plaidRedirectUri = basePlaidRedirectUri.includes(session.merchantId) ? basePlaidRedirectUri : basePlaidRedirectUri + "/" + session.merchantId;
        oprUrl = appKey ? (basePlaidRedirectUri.includes(appKey) ? "?redirectUri=" + basePlaidRedirectUri : "?redirectUri=" + basePlaidRedirectUri + "/" + appKey) : "?redirectUri=" + plaidRedirectUri;
      }
      vipApi.fetch("/api/plaid/link" + oprUrl)
        .then((res) => {
          res.json().then((data) => {
            if (!mounted) return;
            if (res.ok) {
              setLinkToken(data.linkToken);
              localStorage.setItem("link_token", data.linkToken);
            }
            setIsLoading(false);
          });
        })
        .catch(() => { setIsLoading(false) });
      return () => {
        mounted = false;
      };
    }
    if (!session.toggles.plaidEnabled) {
      setIsLoading(false);
    }
  }, []);
  var buttons = (isLoading) ? <Loading /> : <Col xs={12} md={{ span: 8, offset: 2 }} className="center-block">
    {props.plaidProps && <Plaid {...props.plaidProps} linkToken={linkToken} enrollmentStep={props.isEnrollment} receivedRedirectUri={receivedRedirectUri} isPlaidRedirect={props.plaidRedirect} />}
    {/* {props.netspendProps && props.showNetspendCTA && <NetSpend {...props.netspendProps} />} */}
    {props.plaidDefault && props.isEnrollment && <div className='text-center'><b>or</b></div>}
    {props.bankProps && props.showManualCTA && props.isEnrollment && <Manual {...props.bankProps} plaidDefault={props.plaidDefault} enrollmentStep={props.isEnrollment} />}
  </Col>;

  return (
    <>
      {!linkToken && !props.isEnrollment ? ((isLoading) ? <Loading /> : <div style={{ 'width': '100%', 'display': 'inline-block', 'textAlign': 'center' }}>
        <div className="add-funding-source-error" style={{ 'width': '60%', 'display': 'inline-block', 'textAlign': 'center' }}>
          <img src={AddFundingSourceError} alt='Add Funding Source Error' style={{ 'paddingTop': '5px', 'paddingBottom': '10px' }}></img>
          <p>We are unable to add new accounts at this time.</p>
        </div>
      </div>) : <>
        {props.plaidRedirect && <Plaid {...props.plaidProps} linkToken={linkToken} enrollmentStep={props.isEnrollment} receivedRedirectUri={receivedRedirectUri} isPlaidRedirect={props.plaidRedirect} />}
        {(props.plaidRedirect && isLoading) ? <Loading /> : <Row>
          <Col xs={12} className="text-center bank-text">
            Select a payment option
          </Col>
          {buttons}
        </Row>
        }
      </>
      }
    </>
  );
}

export default FundingSourceList;